import { useEffect, useState } from "react";
import { IDropdownData } from "../models/ICommon";
import { Dropdown } from "primereact/dropdown";

interface FloatingLabelDropDownProp {
  label: string;
  onChange: any;
  isMandatory: boolean;
  value: any;
  name: string;
  optionsList: any;
  hideBlankRow?: boolean;
  showClear?: boolean;
  disable?: boolean;
  placeholder?: string;
  defaultAutoSelect?: boolean;
  showFilter?: boolean;
}

const FloatingLabelDropDown = (props: FloatingLabelDropDownProp) => {
  const {
    label,
    isMandatory,
    value,
    name,
    optionsList,
    hideBlankRow,
    showClear = true,
    placeholder = "",
    disable,
    onChange,
    defaultAutoSelect = false,
    showFilter
  } = props;

  const [valueObject, setValueObject] = useState(undefined);

  useEffect(() => {
    if (
      optionsList &&
      (value ||
        typeof value == "boolean" ||
        (typeof value == "number" && value == 0))
    ) {
      const _valueObject = optionsList.find(
        (item: IDropdownData) => item.id?.toString() === value.toString()
      );
      setValueObject(_valueObject);
    } else {
      setValueObject(undefined);
    }
  }, [value, optionsList]);

  useEffect(() => {
    if (optionsList?.length === 1 && defaultAutoSelect == true) {
      onSingleSelect(optionsList[0]);
    }
  }, [optionsList]);

  const onSingleSelect = (data: IDropdownData) => {
    const event: any = {
      target: {
        name: name,
        value: data ? data.id : "",
      },
    };

    onChange(event);
  };

  return (
    // <Dropdown
    //   value={value}
    //   onChange={(e) => onChange(e)}
    //   options={optionsList}
    //   optionLabel="name"
    //   placeholder="Select a Country"
    //   filter
    //   // valueTemplate={selectedCountryTemplate}
    //   // itemTemplate={countryOptionTemplate}
    //   className="w-full md:w-14rem"
    // />

    <>
      <label className="">
        {label}
        {isMandatory && <i className="">*</i>}
      </label>
      <Dropdown
        value={valueObject}
        onChange={(e) => onSingleSelect(e.value)}
        options={optionsList}
        optionLabel="name"
        filter={showFilter}
        showFilterClear
        filterInputAutoFocus
        resetFilterOnHide
        showClear={showClear}
        disabled={disable}
        placeholder={placeholder}
        className="w-full"
      />
    </>
  );
};

export default FloatingLabelDropDown;
